/* Generado por scripts/sync-icons.js desde ruttia-platform/design/iconos/ruttia-icons.json (v1.2.0). No editar a mano. */
export type Shape = ['path', string] | ['circle', number, number, number] | ['rect', number, number, number, number, number?];

export const GRID = 24;
export const STROKE_WIDTH = 1.75;
export const GLYPHS = {
  "route": [
    [
      "path",
      "M4.5 18.75c4.5-.75 4.5-6.75 9-7.5s5.25-6 6-7.5"
    ],
    [
      "circle",
      4.5,
      18.75,
      2.25
    ],
    [
      "circle",
      19.5,
      3.75,
      2.25
    ]
  ],
  "map": [
    [
      "path",
      "M3 6.5l5.5-2.5 7 2.5 5.5-2.5v13.5l-5.5 2.5-7-2.5L3 20z"
    ],
    [
      "path",
      "M8.5 4v13.5M15.5 6.5V20"
    ]
  ],
  "location": [
    [
      "path",
      "M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"
    ],
    [
      "circle",
      12,
      10,
      2.5
    ]
  ],
  "gps": [
    [
      "circle",
      12,
      12,
      6.5
    ],
    [
      "circle",
      12,
      12,
      2
    ],
    [
      "path",
      "M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3"
    ]
  ],
  "directions": [
    [
      "path",
      "M3.5 11.25L20.5 3.5l-7.75 17-2-7.25z"
    ]
  ],
  "reorder": [
    [
      "path",
      "M10 6h10.5M10 12h10.5M10 18h10.5"
    ],
    [
      "path",
      "M4.5 4v16M2.5 6l2-2 2 2M2.5 18l2 2 2-2"
    ]
  ],
  "end-day": [
    [
      "path",
      "M5 21V3.75"
    ],
    [
      "path",
      "M5 4.5h11.5l-2.25 3.75 2.25 3.75H5"
    ]
  ],
  "client": [
    [
      "circle",
      12,
      8,
      3.75
    ],
    [
      "path",
      "M4.5 20.5c.7-4 3.6-6.25 7.5-6.25s6.8 2.25 7.5 6.25"
    ]
  ],
  "client-add": [
    [
      "circle",
      10,
      8,
      3.5
    ],
    [
      "path",
      "M3 20.5c.6-3.8 3.3-6 7-6 1.4 0 2.6.3 3.7.9"
    ],
    [
      "path",
      "M18.5 13.75v6.5M15.25 17h6.5"
    ]
  ],
  "client-remove": [
    [
      "circle",
      10,
      8,
      3.5
    ],
    [
      "path",
      "M3 20.5c.6-3.8 3.3-6 7-6 1.4 0 2.6.3 3.7.9"
    ],
    [
      "path",
      "M15.25 17h6.5"
    ]
  ],
  "clients": [
    [
      "circle",
      9,
      8.5,
      3.25
    ],
    [
      "path",
      "M2.5 20c.6-3.6 3.1-5.6 6.5-5.6s5.9 2 6.5 5.6"
    ],
    [
      "circle",
      16.75,
      7.5,
      2.5
    ],
    [
      "path",
      "M16.5 12.6c2.8-.1 4.6 1.6 5 4.4"
    ]
  ],
  "phone": [
    [
      "path",
      "M6.5 3.5h3l1.5 4-2 1.5a11 11 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4.5 5.5a2 2 0 0 1 2-2z"
    ]
  ],
  "message": [
    [
      "path",
      "M4.5 4.5h15a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H11l-4.5 3.5v-3.5h-2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z"
    ],
    [
      "path",
      "M7.5 9h9M7.5 12.5h6"
    ]
  ],
  "payment": [
    [
      "circle",
      12,
      14.5,
      6.75
    ],
    [
      "path",
      "M14.2 12.6c-.4-.8-1.2-1.2-2.2-1.2-1.2 0-2.1.6-2.1 1.5 0 2.1 4.4 1.1 4.4 3.3 0 .9-.9 1.6-2.3 1.6-1 0-1.9-.4-2.3-1.2M12 10.25v1.15M12 17.8v1"
    ],
    [
      "path",
      "M12 1.75v4.5M9.75 4.25L12 6.5l2.25-2.25"
    ]
  ],
  "loan": [
    [
      "rect",
      2.5,
      8.5,
      15.5,
      10.5,
      2
    ],
    [
      "circle",
      10.25,
      13.75,
      2.25
    ],
    [
      "path",
      "M14.5 3.5h6V9.5M20.5 3.5l-6.5 6.5"
    ]
  ],
  "refinance": [
    [
      "path",
      "M19.5 9A8 8 0 0 0 5.2 7.2M4.5 15a8 8 0 0 0 14.3 1.8"
    ],
    [
      "path",
      "M5 3.25v4h4M19 20.75v-4h-4"
    ],
    [
      "path",
      "M13.9 10.4c-.35-.65-1-.95-1.9-.95-1 0-1.8.5-1.8 1.25 0 1.8 3.8.95 3.8 2.85 0 .8-.8 1.35-2 1.35-.9 0-1.65-.35-2-1"
    ]
  ],
  "cash-box": [
    [
      "rect",
      2.5,
      6,
      19,
      13,
      2.5
    ],
    [
      "circle",
      12,
      12.5,
      2.8
    ],
    [
      "path",
      "M6 9.5v6M18 9.5v6"
    ]
  ],
  "expense": [
    [
      "rect",
      2.5,
      6,
      19,
      13,
      2.5
    ],
    [
      "path",
      "M9 12.5h6"
    ]
  ],
  "receipt": [
    [
      "path",
      "M6 2.75h12v18.5l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5z"
    ],
    [
      "path",
      "M9 7.5h6M9 11h6M9 14.5h4"
    ]
  ],
  "summary": [
    [
      "rect",
      4.75,
      4,
      14.5,
      17.5,
      2.25
    ],
    [
      "path",
      "M9 4V2.75h6V4"
    ],
    [
      "path",
      "M9 17.25v-3M12 17.25v-6.5M15 17.25v-4.5"
    ]
  ],
  "report": [
    [
      "path",
      "M3.5 20.5h17M6.5 16.5v-5M11.5 16.5v-9M16.5 16.5v-6.5"
    ],
    [
      "path",
      "M5 7.5l5-3.5 4 2.5 5-3.5"
    ]
  ],
  "calendar": [
    [
      "rect",
      3,
      4.5,
      18,
      16,
      2.5
    ],
    [
      "path",
      "M3 9.5h18M8 2.5v4M16 2.5v4M7.5 14h3M13.5 14h3M7.5 17h3"
    ]
  ],
  "history": [
    [
      "path",
      "M3.75 12a8.25 8.25 0 1 0 2.4-5.8"
    ],
    [
      "path",
      "M3.5 3.5v4h4"
    ],
    [
      "path",
      "M12 7.75V12l3 2"
    ]
  ],
  "paid": [
    [
      "circle",
      12,
      12,
      8.5
    ],
    [
      "path",
      "M8 12.5l2.75 2.75L16 9.75"
    ]
  ],
  "pending": [
    [
      "circle",
      12,
      12,
      8.5
    ],
    [
      "path",
      "M12 7.5V12l3 2"
    ]
  ],
  "missed": [
    [
      "path",
      "M4 11l8-6.5 8 6.5M6 9.5V20h12V9.5"
    ],
    [
      "path",
      "M10 12.5l4 4M14 12.5l-4 4"
    ]
  ],
  "sync": [
    [
      "path",
      "M20 12a8 8 0 0 1-13.7 5.6M4 12a8 8 0 0 1 13.7-5.6"
    ],
    [
      "path",
      "M17.75 2.5v4h-4M6.25 21.5v-4h4"
    ]
  ],
  "offline": [
    [
      "path",
      "M2 8.5a15 15 0 0 1 20 0M5.5 12a10 10 0 0 1 13 0M9 15.5a5 5 0 0 1 6 0"
    ],
    [
      "circle",
      12,
      19,
      1.4
    ],
    [
      "path",
      "M4 3l16 18"
    ]
  ],
  "edit": [
    [
      "path",
      "M4 20l1-4.5L15.5 5a2.1 2.1 0 0 1 3 3L8 18.5z"
    ],
    [
      "path",
      "M13.5 7l3 3"
    ]
  ],
  "delete": [
    [
      "path",
      "M4 6.5h16M9.5 6.5V4h5v2.5M6 6.5l1 14h10l1-14"
    ],
    [
      "path",
      "M10 10.5v6M14 10.5v6"
    ]
  ],
  "info": [
    [
      "circle",
      12,
      12,
      8.5
    ],
    [
      "path",
      "M12 11v5.5M12 7.75v.01"
    ]
  ],
  "lock": [
    [
      "rect",
      5,
      10.5,
      14,
      10,
      2
    ],
    [
      "path",
      "M8 10.5V8a4 4 0 0 1 8 0v2.5"
    ]
  ],
  "office": [
    [
      "path",
      "M4.5 21V5.5L12 3l7.5 2.5V21"
    ],
    [
      "path",
      "M2.5 21h19"
    ],
    [
      "path",
      "M8.5 9h1.5M14 9h1.5M8.5 13h1.5M14 13h1.5"
    ],
    [
      "path",
      "M10.5 21v-3.5h3V21"
    ]
  ],
  "inventory": [
    [
      "path",
      "M3 7.5l9-4.5 9 4.5v9l-9 4.5-9-4.5z"
    ],
    [
      "path",
      "M3 7.5l9 4.5 9-4.5M12 12v9"
    ]
  ],
  "assistant": [
    [
      "path",
      "M4.5 4.5h15a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H11l-4.5 3.5v-3.5h-2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z"
    ],
    [
      "path",
      "M7 14c2.2-.3 2.2-3.2 4.5-3.5s2.8-2.2 3.5-3"
    ],
    [
      "circle",
      16,
      7.5,
      1
    ]
  ],
  "home": [
    [
      "path",
      "M3.5 11L12 4l8.5 7"
    ],
    [
      "path",
      "M5.5 9.5V20h13V9.5"
    ],
    [
      "path",
      "M10 20v-5h4v5"
    ]
  ],
  "settings": [
    [
      "path",
      "M4 7h8.5M17.5 7H20M4 17h2.5M11.5 17H20"
    ],
    [
      "circle",
      15,
      7,
      2.5
    ],
    [
      "circle",
      9,
      17,
      2.5
    ]
  ],
  "users": [
    [
      "rect",
      3,
      5,
      18,
      14,
      2.5
    ],
    [
      "circle",
      9,
      10.75,
      2
    ],
    [
      "path",
      "M5.75 16.25c.5-1.6 1.7-2.5 3.25-2.5s2.75.9 3.25 2.5"
    ],
    [
      "path",
      "M14.5 10h4M14.5 13.5h3"
    ]
  ],
  "sales-rep": [
    [
      "circle",
      9,
      7.75,
      3.25
    ],
    [
      "path",
      "M2.5 20c.6-3.6 3.1-5.6 6.5-5.6 1.5 0 2.8.4 3.8 1.1"
    ],
    [
      "path",
      "M18 21s-3.5-3-3.5-6a3.5 3.5 0 0 1 7 0c0 3-3.5 6-3.5 6z"
    ],
    [
      "circle",
      18,
      15,
      1.2
    ]
  ],
  "bank": [
    [
      "path",
      "M3 9.5L12 4l9 5.5"
    ],
    [
      "path",
      "M4 9.5h16"
    ],
    [
      "path",
      "M6.5 12.5v5M10.5 12.5v5M13.5 12.5v5M17.5 12.5v5"
    ],
    [
      "path",
      "M3 20.5h18"
    ]
  ],
  "import": [
    [
      "path",
      "M12 15V3.5M7.5 8L12 3.5 16.5 8"
    ],
    [
      "path",
      "M4 14.5v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4"
    ]
  ],
  "export": [
    [
      "path",
      "M12 3.5V15M7.5 10.5L12 15l4.5-4.5"
    ],
    [
      "path",
      "M4 14.5v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4"
    ]
  ],
  "transfer": [
    [
      "path",
      "M4 8h14.5M15 4.5L18.5 8 15 11.5"
    ],
    [
      "path",
      "M20 16H5.5M9 12.5L5.5 16 9 19.5"
    ]
  ],
  "device": [
    [
      "rect",
      6.5,
      2.5,
      11,
      19,
      2.5
    ],
    [
      "path",
      "M10.5 18.25h3"
    ]
  ],
  "notice": [
    [
      "path",
      "M4 10v4a1 1 0 0 0 1 1h2l6 4.5v-15L7 9H5a1 1 0 0 0-1 1z"
    ],
    [
      "path",
      "M17 9.5a3.5 3.5 0 0 1 0 5M19.5 7a7 7 0 0 1 0 10"
    ]
  ],
  "stock-in": [
    [
      "path",
      "M3.5 14h4.5l1.5 2.5h5l1.5-2.5h4.5"
    ],
    [
      "path",
      "M6 7.5h-.25L3.5 14v4.5a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V14l-2.25-6.5H18"
    ],
    [
      "path",
      "M12 2.5v9M9 8.5l3 3 3-3"
    ]
  ],
  "stock-out": [
    [
      "path",
      "M3.5 14h4.5l1.5 2.5h5l1.5-2.5h4.5"
    ],
    [
      "path",
      "M6 7.5h-.25L3.5 14v4.5a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V14l-2.25-6.5H18"
    ],
    [
      "path",
      "M12 11.5v-9M9 5.5l3-3 3 3"
    ]
  ],
  "return": [
    [
      "path",
      "M9 5L4.5 9.5 9 14"
    ],
    [
      "path",
      "M4.5 9.5h10a5 5 0 0 1 0 10H11"
    ]
  ],
  "alert": [
    [
      "path",
      "M10.3 4.6L3.2 17.1A2 2 0 0 0 4.9 20h14.2a2 2 0 0 0 1.7-2.9L13.7 4.6a2 2 0 0 0-3.4 0z"
    ],
    [
      "path",
      "M12 9.5v4.25M12 16.75v.01"
    ]
  ]
} as const;

export type GlyphName = keyof typeof GLYPHS;
